<template>
    <!-- 检验 -->
    <el-container class="test-page" v-loading="loading">
        <div class="header">
            <div class="text"><span>标准数据库 / </span><span>检验</span></div>
            <div class="content">
                <div class="search">
                    <el-input placeholder="请输入检验项目名称" style="width:20%;margin-right:20px" size='small'
                        v-model="searchForm.searchCondition">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <div style="margin-right:10px">检验类别：</div>
                    <el-select v-model="searchForm.firstCategoryId" filterable size='small' placeholder="请选择检验类别大类"
                        style="margin-right:20px" @change="categoryNameChange">
                        <el-option v-for="(item, index) in drugArr" :key="index" :label="item.categoryName"
                            :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="searchForm.secondCategoryId" filterable size='small' placeholder="请选择检验类别小类"
                        @input="change($event)" style="margin-right:20px">
                        <el-option v-for="(item, index) in drugArrTwo" :key="index" :label="item.categoryName"
                            :value="item.id"></el-option>
                    </el-select>
                    <el-button size='small' style="margin-right:10px;"
                        @click="searchForm = {}; drugArrTwo = []">重置</el-button>
                    <el-button type="primary" size='small' @click="searchData"
                        style="background:#1A7BFC;border-color:#1A7BFC">搜索</el-button>
                </div>
                <div class="excel-crtol">
                    <el-button size='small' style="margin-right:10px;" @click="addDialog">新增检验类别</el-button>
                    <el-button type="primary" size='small' style="margin-right:10px" @click="addProject"
                        plain>新增检验项目</el-button>
                </div>
            </div>
        </div>
        <el-main class="main">
            <div class="content">
                <div class="text">检验项目列表</div>
                <el-scrollbar style="height: calc(100% - 60px); font-size: 12px; width: 100%; padding: 18px;">
                    <el-table id="tableInfo" :data="tableData" style="width: 100%">
                        <el-table-column type='index' fixed label="序号" align="center"></el-table-column>
                        <el-table-column prop="firstCategoryName" label="检验类别大类" align="center"></el-table-column>
                        <el-table-column prop="secodeCategoryName" label="检验类别小类" align="center"></el-table-column>
                        <el-table-column prop="code" label="检验项目编码" align="center"></el-table-column>
                        <el-table-column prop="abbreviation" label="检验项目简称" align="center"></el-table-column>
                        <el-table-column prop="name" label="检验项目全称" align="center"></el-table-column>
                        <el-table-column prop="propertyName" label="检验结果属性" align="center"></el-table-column>
                        <el-table-column prop="range" label="参考范围" align="center"></el-table-column>
                        <el-table-column prop="doseUnit" label="检验定量结果计量单位" align="center">
                            <template slot-scope="scope">{{ scope.row.propertyName == '定性' ? '-' :
                                scope.row.propertyName == '定量' ? scope.row.doseUnit : ''}}</template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button @click="editClass(scope.row, scope.$index)" type="text"
                                    size="small">编辑</el-button>
                                <el-button type="text" size="small" v-if="scope.row.status == true"
                                    @click="enable(scope.row)">启用</el-button>
                                <el-button type="text" size="small" v-if="scope.row.status == false"
                                    @click="enable(scope.row)">停用</el-button>
                                <el-button @click="deleteStatus(scope.row, scope.$index)" type="text"
                                    size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="searchForm.current" :page-size="searchForm.size"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-scrollbar>
            </div>
        </el-main>
        <AddCategory ref="addCategory" />
        <AddProject ref="addProject" />
    </el-container>
</template>

<script>
import AddCategory from './components/AddCategory/index'
import AddProject from './components/AddProject/index'
import { apiiInspectionInfo, apiStandardInfoUpdate, apiPutInspectionStatus, apiDeleteInspection } from '../case-3/api/index'
export default {
    components: {
        AddCategory,
        AddProject
    },
    data() {
        return {
            searchForm: {
                searchCondition: "",//输入框搜索字段
                firstCategoryId: "",
                secondCategoryId: "",
                current: 1,//页数
                size: 10,//每页多少条
            },
            tableData: [],
            total: 0,//每页10条
            drugArr: [],
            drugArrTwo: [],
            loading: false,
            limitUpload: 1,
        }
    },
    created() {
        this.getTestList()
    },
    methods: {
        /**
         * @description:  进入页面获取列表接口 查询分类接口
         * @param {*}
         * @return {*}
        */
        getTestList() {
            apiiInspectionInfo({ ...this.searchForm }).then(res => {
                this.tableData = res.data.records
                this.total = res.data.total
            })
            //获取大分类下拉框数据
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: 0,
            }).then(res => {
                this.drugArr = res.data
            })
        },
        /**
        * @description:  查询
        * @param {*}
        * @return {*}
       */
        searchData() {
            this.getTestList()
        },
        /**
         * @description:  根据选择的大类 获取小类
         * @param {*}
         * @return {*}
        */
        categoryNameChange(val) {
            this.searchForm.secondCategoryId = ''
            apiStandardInfoUpdate({
                status: false,
                type: 2,
                parentId: val,
            }).then(res => {
                this.drugArrTwo = res.data
            })
        },
        /**
         * @description:  分页组件事件
         * @param {*}
         * @return {*}
        */
        handleSizeChange(val) {
            this.searchForm.size = val
            this.getTestList()
        },
        handleCurrentChange(val) {
            this.searchForm.current = val
            this.getTestList()
        },
        /**
         * @description:  新增检验类别弹窗
         * @param {*}
         * @return {*}
        */
        addDialog() {
            this.$refs.addCategory.openDialog()
        },
        /**
         * @description:  新增检验项目弹窗
         * @param {*}
         * @return {*}
        */
        addProject() {
            this.$refs.addProject.openDialog()
        },
        /**
        * @description:  检验项目启用停用
        * @param {*}
        * @return {*}
       */
        enable(row) {
            this.loading = true
            apiPutInspectionStatus(row.id).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    row.status = !row.status
                    this.loading = false
                } else {
                    this.$message.error(res.message);
                    this.loading = false
                }
            }).catch(e => {
                this.loading = false
            })
        },
        /**
         * @description:  删除项目
         * @param {*}
         * @return {*}
        */
        deleteStatus(row, index) {
            this.$confirm('是否要删除当前检检验项目全部信息吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                customClass: 'message-confirm-style'
            }).then(() => {
                this.loading = true
                apiDeleteInspection(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '成功',
                            type: 'success'
                        });
                        this.loading = false
                        this.tableData.splice(index, 1)
                        this.getTestList()
                    } else {
                        this.$message.error(res.message);
                        this.loading = false
                    }
                }).catch(e => {
                    this.loading = false
                })
            })
        },
        /**
         * @description:  编辑项目
         * @param {*}
         * @return {*}
        */
        editClass(row, index) {
            this.$refs.addProject.editProject(row)
        },
        /**
         * @description:  导出Excel
         * @param {*}
         * @return {*}
        */
        outExcel() {
            window.location.href = "excel地址"
            // let table = document.querySelector("#tableInfo").cloneNode(true);
            // table.removeChild(table.querySelector(".el-table__fixed-right"));
            // table.removeChild(table.querySelector(".el-table__fixed"));
            // let wb = XLSX.utils.table_to_book(table, { raw: true });
            // var wbout = XLSX.write(wb, {
            //     bookType: "xlsx",
            //     bookSST: true,
            //     type: "array",
            // });
            // try {
            //     FileSaver.saveAs(
            //         new Blob([wbout], { type: "application/octet-stream" }),
            //         "检查项目.xlsx"
            //     );
            // } catch (e) {
            //     if (typeof console !== "undefined") 
            // }
            // return wbout;
        },
        //el数据input 无法输入解决办法
        change(e) {
            this.$forceUpdate();
        },
        /**
         * @description:  导入excel
         * @param {*}
         * @return {*}
        */
        //选择好文件后
        fileBefore(e) {
            if (e.type != 'application/vnd.ms-excel') {
                alert("文件格式不对")
                return false
            }
        },
        //上传成功
        fileSuccess() {
            alert("上传成功")
        },
        //上传失败
        fileError() {
            alert("上传失败")
        },
    },
}
</script>

<style lang="less" scoped>
.test-page {
    height: 100%;
    width: 100%;
    background: #F8F8F8;
    position: absolute;
    left: 0;
    display: flex;
    flex-direction: column;

    .header {
        padding: 20px;
        width: 100%;
        background: #fff;

        .text {
            margin-bottom: 20px;
            color: #333333;
            font-size: 14px;

            span:nth-child(2) {
                color: #000000;
            }

            span:nth-child(1) {
                color: #666666;
            }
        }

        .content {
            display: flex;
            justify-content: space-between;

            .search {
                display: flex;
                align-items: center;
                flex: 1;
            }
        }

    }

    .main {
        width: 100%;
        padding: 15px;

        .content {
            height: 100%;
            width: 100%;
            border-radius: 5px;
            background: #fff;
            overflow: hidden;
            padding-bottom: 0;

            .text {
                color: #333333;
                font-size: 14px;
                margin-left: 18px;
                margin-top: 18px;
            }
        }
    }

    .excel-crtol {
        display: flex;
    }
}

/deep/.el-button--primary.is-plain {
    background: rgb(26, 123, 252);
    color: #fff;
    border-color: rgb(26, 123, 252);
}

/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}

/deep/.el-table__header-wrapper {
    background-color: #FAFAFA;
}

/deep/.el-table th>.cell {
    color: #333;
    font-weight: bold;
}

/deep/.el-table th {
    background: #FAFAFA;
}

/deep/.el-pagination {
    text-align: right;
    margin-top: 10px;
}
</style>
